import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import apiReducer from './api';
import layoutReducer from './layout';
import rideAdminReducer from './rideAdmin';
import routeBlockageDetailReducer from './routeBlockageDetail';
import sessionReducer from './session';

const rootReducer = combineReducers({
  api: apiReducer,
  form: formReducer,
  layout: layoutReducer,
  rideAdmin: rideAdminReducer,
  routeBlockageDetail: routeBlockageDetailReducer,
  session: sessionReducer,
});

export default rootReducer;
